"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockElementData = void 0;
exports.createMockElementEndPoint = createMockElementEndPoint;
exports.createMockElements = createMockElements;
const shared_1 = require("@buildwithflux/shared");
const helpers_1 = require("../helpers");
const mockPartData_1 = require("./mockPartData");
const mockPrimitiveData_1 = require("./mockPrimitiveData");
const mockPropertyData_1 = require("./mockPropertyData");
const mockElementData = (overrides, propertyAmount) => {
    const partVersionData = (0, mockPartData_1.createMockPartAndVersionData)().versions.HEAD;
    return {
        uid: helpers_1.chance.guid(),
        owner_uid: helpers_1.chance.guid(),
        created_at: helpers_1.chance.timestamp(),
        updated_at: helpers_1.chance.timestamp(),
        label: helpers_1.chance.animal(),
        part_uid: partVersionData.part_uid,
        part_version: partVersionData.version,
        part_version_data_cache: partVersionData,
        diagram_position: (0, mockPrimitiveData_1.mockVector2)(),
        symbol_placements: { main: { x: 0, y: 0, orientation: 0 } },
        properties: {
            ...partVersionData.properties,
            ...(0, mockPropertyData_1.mockPropertiesMap)(propertyAmount),
        },
        ...overrides,
    };
};
exports.mockElementData = mockElementData;
function createMockElementEndPoint(overrides) {
    return {
        uid: helpers_1.chance.guid(),
        element_uid: helpers_1.chance.guid(),
        terminal_uid: helpers_1.chance.guid(),
        ...overrides,
    };
}
function createMockElements(elementsAmount, partsAmount) {
    const result = {};
    // TODO: there is a bug in the sub layout part mocking that creates a infinite loop
    // setting the amount to zero for now
    const mockParts = (0, mockPartData_1.createMockParts)(partsAmount, 0);
    for (let i = 0; i < elementsAmount; i++) {
        const element = (0, exports.mockElementData)({
            part_version_data_cache: (0, shared_1.getRandomArrayItem)(mockParts),
            diagram_position: (0, mockPrimitiveData_1.mockVector2)(),
        });
        result[element.uid] = element;
    }
    return result;
}
//# sourceMappingURL=mockElementData.js.map